module.exports = __webpack_public_path__ + "img/dateblack.6d1f1680.svg";